// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1RJEC","notes":"Notes_notes__19P25"};